/**
 * @packageDocumentation
 * @module HackerAPI.Email
 */
import { __extends } from "tslib";
import Base from "../base/base";
import HackerAPIFetch from "../hackerapi-fetch/hackerapi-fetch";
import Trigger from "./trigger/trigger";
import Template from "./template/template";
import { parseDate } from "../utils/utils";
/**
 * Class containing all hackerapi email functionality
 * @class
 * @extends { HackerAPI.Base }
 */
var Email = /** @class */ (function (_super) {
    __extends(Email, _super);
    /**
     * Creates a new Mail instance
     * @constructor
     * @param email
     */
    function Email(_a) {
        var _b = _a === void 0 ? {} : _a, id = _b.id, send_time = _b.send_time, sendTime = _b.sendTime, to_email = _b.to_email, toEmail = _b.toEmail, targetEmail = _b.targetEmail, subject = _b.subject, html = _b.html, campaign = _b.campaign, context = _b.context, created_at = _b.created_at, createdAt = _b.createdAt, updated_at = _b.updated_at, updatedAt = _b.updatedAt;
        var _this = _super.call(this, {
            sendTime: function (k, v) {
                return v ? ["send_time", Base.dateTimeHandler(k, v)] : ["immediate", true];
            },
            targetEmail: function (k, v) { return ["to_email", v]; }
        }) || this;
        /**
         * @type { number }
         */
        _this.id = id;
        /**
         * When the email is to be sent (blank for now)
         * @type { Date }
         */
        _this.sendTime = parseDate(send_time || sendTime);
        /**
         * Target email to send to
         * @type { string }
         */
        _this.targetEmail = to_email || toEmail || targetEmail;
        /**
         * @type { string }
         */
        _this.subject = subject;
        /**
         * @type { string }
         */
        _this.html = html;
        /**
         * @type { string }
         */
        _this.campaign = campaign;
        /**
         * @type { Object }
         */
        _this.context = context;
        /**
         * @type { Date }
         */
        _this.createdAt = parseDate(created_at || createdAt);
        /**
         * @type { Date }
         */
        _this.updatedAt = parseDate(updated_at || updatedAt);
        return _this;
    }
    Object.defineProperty(Email, "Template", {
        /**
         * @returns
         */
        get: function () {
            return Template;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Email, "Trigger", {
        /**
         * @returns
         */
        get: function () {
            return Trigger;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Creates a new email
     * @param email
     * @param token
     * @returns
     */
    Email.send = function (email, token) {
        return HackerAPIFetch({
            path: "/v2/emails",
            method: "POST",
            body: email.toHackerAPIFormat(),
            token: token
        }).then(function (data) { return new Email(data); });
    };
    /**
     * Creates a batch of emails
     * @param email - .targetEmail is ignored
     * @param targets - Array of emails or array of objects that contain emails
     * @param [token]
     * @returns
     */
    Email.sendBatch = function (email, targets, token) {
        var body = email.toHackerAPIFormat();
        body.recipient_info = targets;
        return HackerAPIFetch({
            path: "/v2/emails",
            method: "PATCH",
            body: body,
            token: token
        }).then(function (data) { return data.map(function (datum) { return new Email(datum); }); });
    };
    return Email;
}(Base));
export default Email;
//# sourceMappingURL=email.js.map